module.exports = __webpack_public_path__ + "static/logo-a600180d9ca0526ec6ed6b93195ba81f.jpg";